import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { SearchInput } from "../../components";
import { Typography } from "@mui/material";
import { getPreprocessedData } from "../../utils/Helper";
import { ApiService } from "../../utils/ApiService";
import { API_URL } from "../../utils/Constants";
import { GlobalSearchStyled } from "./styled";
import { ROUTES } from "../../config/routes";
import { TEXT_ALIGN_LEFT, TEXT_DECORATION_NONE } from "../../config/styles";
import { GlobalSearchLogo, MerchantLogo } from "../../assets/icons";
import { GLOBAL_SEARCH_CONSTANTS } from "../../config/constants";
import { colors } from "../../config/colors";

const GlobalSearch = () => {
  const [searchString, setSearchString] = useState("");
  const [studentValueList, setStudentValueList] = useState([]);

  useEffect(() => {
    fetchSearchedSchools();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchString]);

  const handleSearch = (event) => {
    const searchString = event.target.value;
    setSearchString(searchString);
  };
  const fetchSearchedSchools = async () => {
    if (searchString.length === 0 || !searchString) {
      return;
    } else {
      const url =
        API_URL.FETCH_MERCHANT_WILDCARD + searchString + "?offset=0&limit=10";
      const resp = await ApiService.getRequest(url);
      if (resp?.status?.code === "Y") {
        setStudentValueList(getPreprocessedData(resp.body));
      }
    }
  };
  return (
    <GlobalSearchStyled>
      <div className="welcome-page-container">
        <div className="welcome-page-header pb-0">
          <Typography variant="body2" component="div">
            {GLOBAL_SEARCH_CONSTANTS.HEADER}
          </Typography>
        </div>
        <div className="welcome-page-header py-4">
          <SearchInput
            id="schoolName"
            label="Search"
            value={searchString}
            style={{ width: "100%" }}
            placeholder={GLOBAL_SEARCH_CONSTANTS.SEARCH_PLACEHOLDER}
            onChange={handleSearch}
            iconPosition="start"
          />
        </div>
        {searchString ? (
          <>
            <div className="welcome-page-header py-0">
              <div className="search-icon-text mb-2">
                {GLOBAL_SEARCH_CONSTANTS.MERCHANTS}
              </div>
            </div>
            <div className="search-container">
              {studentValueList.map((item) => {
                const onClickHandler = () => {
                  localStorage.setItem("globalMerchantId", item.merchantId);
                  localStorage.setItem("superAdminSchoolName", item.name);
                  localStorage.setItem("icon", item.icon);
                  localStorage.setItem(
                    "schoolDataProvided",
                    item.schoolDataProvided
                  );
                };
                return (
                  <Link
                    className="search-bar-item"
                    to={ROUTES.STUDENT_DATA}
                    style={{
                      textDecoration: TEXT_DECORATION_NONE,
                      overflow: "clip",
                      whiteSpace: "nowrap",
                    }}
                    key={item.merchantId}
                    onClick={onClickHandler}
                  >
                    <div className="search-bar-logo-item">
                      <MerchantLogo />
                    </div>
                    <div>
                      <Typography
                        variant="body1"
                        component="div"
                        sx={{ textAlign: TEXT_ALIGN_LEFT,
                          color: colors.custom
                         }}
                      >
                        {item.name}
                      </Typography>
                      <div className="search-bar-input">{item.category}</div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </>
        ) : (
          <div className="welcome-page-header py-0 justify-content-center">
            <div className="search-page-container">
              <GlobalSearchLogo />
              <Typography variant="h5" component="div" className="text-center">
                {GLOBAL_SEARCH_CONSTANTS.EMPTY_HEADER}
              </Typography>

              <div className="search-page-empty-text">
                {GLOBAL_SEARCH_CONSTANTS.EMPTY_MESSAGE}
              </div>
            </div>
          </div>
        )}
      </div>
    </GlobalSearchStyled>
  );
};

export default GlobalSearch;
